<script lang="ts">
    import {onDestroy} from 'svelte'

    export let date
    export let status

    let seconds = 0
    let minutes = 0
    let hours = 0
    let endDate = 0

    if (status === 'sending') {
        endDate = new Date(date).getTime() + 60 * 60 * 1000
    } else if (status === 'pending') {
        endDate = new Date(date).getTime() + 12 * 60 * 60 * 1000
    }

    function updateSeconds() {
        const now = new Date().getTime()
        seconds = Math.floor((endDate - now) / 1000)
        minutes = Math.floor(seconds / 60)
        hours = Math.floor(minutes / 60)
        if (seconds <= 0) {
            clearInterval(interval)
        }
    }

    const interval = setInterval(updateSeconds, 1000)

    onDestroy(() => clearInterval(interval));
    console.log('yes')
</script>

{#if status === 'sending'}
    {#if seconds > 0}
        <span class="times">Will expire in
            {#if minutes > 0}<span class="notranslate">{minutes}</span>m
            {:else if seconds > 0}<span class="notranslate">{seconds}</span>s{/if}
        </span>
    {:else}
        <span class="times">Loading...</span>
    {/if}
{:else if status === 'pending'}
    {#if seconds > 0}
        <span class="times">Is left:
            {#if hours > 0}<span class="notranslate">{hours}</span>h
            {:else if minutes > 0}<span class="notranslate">{minutes}</span>m
            {:else if seconds > 0}<span class="notranslate">{seconds}</span>s{/if}
        </span>
    {:else}
        <span class="times">Coming soon...</span>
    {/if}
{/if}

<style>
    .times {
        font-size: 12px;
        padding-left: 6px;
        position: absolute;
        color: #cad5e0;
        margin: 0 0 0 -5px;
        top: 28px;
        line-height: normal;
    }

    @media(max-width: 767px) {
        .times {
            position: relative;
            top: auto;
            margin: 2px 0 -2px 0;
            line-height: 20px;
        }
    }
</style>
